import type { Permission, Role } from '../../../shared/types';

/* Mirrors server/src/lib/permissions.ts — kept in sync manually for UI affordances. */
export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  super_admin: ['client.view','client.edit','client.delete','financial.view','financial.edit','advice.create','advice.approve','audit.read','users.manage','export.run'],
  principal_adviser: ['client.view','client.edit','financial.view','financial.edit','advice.create','advice.approve','audit.read','export.run'],
  adviser: ['client.view','client.edit','financial.view','financial.edit','advice.create','export.run'],
  support_staff: ['client.view','client.edit','financial.view'],
  compliance_officer: ['client.view','financial.view','audit.read','export.run','advice.approve'],
};

export function can(role: Role | undefined, perm: Permission): boolean {
  if (!role) return false;
  return ROLE_PERMISSIONS[role].includes(perm);
}
